import {
  differenceInCalendarDays,
  isLeapYear,
  isWithinRange,
  setSeconds,
  setYear,
  startOfDay,
  subDays,
  subMonths,
} from 'date-fns'
import formatDate from '../DateFormat/formatDate'
import i18n from '../../i18n'

export const formatPeriod = (period, year = undefined) => {
  if (!year) {
    return `${formatDate(
      period.from,
      period.from &&
        period.to &&
        period.from.getFullYear() !== period.to.getFullYear(),
    )} - ${formatDate(period.to, true)} ${i18n.t('OUT_4928_to')} ${formatDate(
      period.diffFrom,
      period.diffFrom &&
        period.diffTo &&
        period.diffFrom.getFullYear() !== period.diffTo.getFullYear(),
    )} - ${formatDate(period.diffTo, true)}`
  } else {
    if (typeof year === 'number') {
      let to = setYear(period.to || 0, year)
      let from = setYear(period.from || 0, year)

      const isLeapTo =
        (isLeapYear(period.to) || isLeapYear(period.from)) &&
        isWithinRange(
          new Date(
            (isLeapYear(period.from) ? period.from : period.to).getFullYear(),
            1,
            29,
          ),
          period.from,
          period.to,
        )

      const isLeapFrom =
        (isLeapYear(from) || isLeapYear(to)) &&
        isWithinRange(
          setSeconds(
            new Date((isLeapYear(from) ? from : to).getFullYear(), 1, 28),
            2,
          ),
          from,
          to,
        )

      if (isLeapTo) {
        to = subDays(to, -1)
      }

      if (isLeapFrom) {
        from = subDays(from, -1)
      }

      return `${formatDate(
        period.from,
        period.from &&
          period.to &&
          period.from.getFullYear() !== period.to.getFullYear(),
      )} - ${formatDate(period.to, true)} ${i18n.t('OUT_4928_to')} ${formatDate(
        from,
        period.from &&
          period.to &&
          period.from.getFullYear() !== period.to.getFullYear(),
      )} - ${formatDate(to, true)}`
    } else {
      return `${formatDate(
        period.from,
        period.from &&
          period.to &&
          period.from.getFullYear() !== period.to.getFullYear(),
      )} - ${formatDate(period.to, true)} ${i18n.t('OUT_4928_to')} ${formatDate(
        setYear(period.from, year[0]),
        period.from &&
          period.to &&
          period.from.getFullYear() !== period.to.getFullYear(),
      )} - ${formatDate(setYear(period.to, year[1]), true)}`
    }
  }
}

export default function(type, dates) {
  const dateToday = startOfDay(new Date())

  const dateFrom = dates.dateFrom

  switch (type) {
    case 0:
      return {
        to: dates.dateTo,
        from: dateFrom,
        diffTo: subDays(dateFrom, 1),
        diffFrom: subDays(
          dates.dateFrom,
          differenceInCalendarDays(dates.dateTo, dates.dateFrom) + 1,
        ),
      }
    case 1:
      return {
        to: dateToday,
        from: subMonths(dateToday, 1),
        diffTo: subDays(subMonths(dateToday, 1), 1),
        diffFrom: subMonths(dateToday, 2),
      }
    case 2:
      return {
        to: dateToday,
        from: subMonths(dateToday, 3),
        diffTo: subDays(subMonths(dateToday, 3), 1),
        diffFrom: subMonths(dateToday, 6),
      }
    case 3:
      return {
        to: dateToday,
        from: subMonths(dateToday, 6),
        diffTo: subDays(subMonths(dateToday, 6), 1),
        diffFrom: subMonths(dateToday, 12),
      }
    case 4:
      return {
        to: dateToday,
        from: subMonths(dateToday, 12),
        diffTo: subDays(subMonths(dateToday, 12), 1),
        diffFrom: subMonths(dateToday, 24),
      }
  }
}
